import { IAppContext } from 'App/AppContext';
import { DBProcesLoggerLogLevel, LogDTO } from 'models/dto/logDTO';
import { apiAddProcessLog } from 'services/Api/userService';
import { apiRequest } from 'services/Auth/authConfig';
import AppError from 'utils/appError';
import { toApiDateTimeRequired } from 'utils/datetime';
import { safeStringify } from 'utils/stringify';

export const globalLog: LogDTO = new LogDTO('Global client log');

export function getLogWithDateStamp(log: string | undefined): string | undefined {
  try {
    if (!log) return undefined;
    if (!log.startsWith('[')) {
      return `[${toApiDateTimeRequired(new Date())}] ${log}`;
    } else {
      return log;
    }
  } catch {
    return log;
  }
}

function info(msg: string | undefined): void {
  if (msg) globalLog.add(getLogWithDateStamp(msg));
  console.info(msg);
}

function error(err: AppError | undefined): void {
  const safePayloadStr = err ? safeStringify(err) : 'Empty error object';

  if (safePayloadStr) globalLog.add(getLogWithDateStamp(safePayloadStr));

  if (err) {
    globalLog.appError = err;
    globalLog.level = DBProcesLoggerLogLevel.Error;
  }

  console.error(safePayloadStr);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function debug(msg: string | undefined, payload?: any): void {
  if (msg) globalLog.add(getLogWithDateStamp(msg));

  if (payload !== undefined) {
    const safeStr = safeStringify(payload);
    globalLog.add(getLogWithDateStamp(safeStr));

    // If you still want structured console output:
    const safeObj = JSON.parse(safeStr);
    console.debug(msg, safeObj);
  } else {
    console.debug(msg);
  }
}

async function upload(appContext: IAppContext): Promise<boolean> {
  try {
    if (globalLog.messages.length === 0) return false;

    const accessToken = await appContext.getAccessToken(apiRequest.scopes);
    globalLog.level = DBProcesLoggerLogLevel.Error; //when set to error, the back-end creates a support ticket
    await apiAddProcessLog(globalLog, accessToken);
    globalLog.clear();

    return true;
  } catch (err) {
    console.debug('Error while uploading global client log to API', err);

    throw err;
  }
}

const logService = { info, debug, error, upload };

export default logService;
